import Tooltip from 'antd/lib/tooltip';
import Typography from 'antd/lib/typography';
import * as React from 'react';
import { runwayColors } from '../styles/globalStyles';
import { ThunderboltFilled, ExclamationCircleFilled } from '@ant-design/icons';

export const generateAutomationThunderboltIcon: (args: {
    isUsedForAutoAccelerate: boolean;
    isUsedForAutoHalt: boolean;
    prefix?: string;
}) => React.ReactNode = ({ isUsedForAutoAccelerate, isUsedForAutoHalt, prefix }) => {
    return (
        (isUsedForAutoAccelerate || isUsedForAutoHalt) && (
            <Tooltip
                title={() => {
                    if (isUsedForAutoAccelerate && isUsedForAutoHalt) {
                        return (
                            <Typography.Text
                                style={{
                                    color: 'white',
                                }}
                            >
                                {prefix} <strong>Release stable phased releases to 100% of users</strong> and{' '}
                                <strong>the Halt unstable phased releases</strong> automations.
                            </Typography.Text>
                        );
                    } else if (isUsedForAutoAccelerate) {
                        return (
                            <Typography.Text
                                style={{
                                    color: 'white',
                                }}
                            >
                                {prefix} <strong>Release stable phased releases to 100% of users</strong> automation.
                            </Typography.Text>
                        );
                    } else if (isUsedForAutoHalt) {
                        return (
                            <Typography.Text
                                style={{
                                    color: 'white',
                                }}
                            >
                                {prefix} <strong>Halt unstable phased releases</strong> automation.
                            </Typography.Text>
                        );
                    }

                    return null;
                }}
            >
                <ThunderboltFilled style={{ color: runwayColors.primary }} />
            </Tooltip>
        )
    );
};

export const generateAutomationAlertIcon: () => React.ReactNode = () => {
    return (
        <Tooltip title="Set up a product health threshold in Monitoring settings.">
            <ExclamationCircleFilled style={{ color: runwayColors.statusYellow }} />
        </Tooltip>
    );
};
